import React from 'react';
import PropTypes from 'prop-types';
import MatchDetailPlayersCardsTable from '../MatchDetailPlayersCardsTable/MatchDetailPlayersCardsTable';
import './_MatchDetailPlayersSection.scss';

const MatchDetailPlayersSection = ({ title, players, statKeys }) => {
  if (!players || !players.length) return null;

  return (
    <section className="match-detail-players-section">
      <h3 className="match-detail-players-section__title">{title}</h3>
      <MatchDetailPlayersCardsTable players={players} statKeys={statKeys} />
    </section>
  );
};

MatchDetailPlayersSection.propTypes = {
  title: PropTypes.string,
  players: PropTypes.array,
  statKeys: PropTypes.array
};

MatchDetailPlayersSection.defaultProps = {
  title: '',
  players: [],
  statKeys: []
};

export default MatchDetailPlayersSection;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailPlayersSection/MatchDetailPlayersSection.jsx